import React, { useState } from 'react';
import { Modal } from './ui/Modal';
export function Footer() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  return <>
      <footer className="py-8 bg-cream border-t border-navy/5" data-id="element-49">
        <div className="max-w-4xl mx-auto px-4 flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-50">
          <p className="text-navy/40 text-sm" data-id="element-51">
            © {new Date().getFullYear()} Protocolo 10 Días. Todos los derechos
            reservados.
          </p>
          <div className="flex items-center gap-6" data-id="element-52">
            <button onClick={() => setShowPrivacy(true)} className="text-sm text-navy/40 hover:text-navy/70 transition-colors underline underline-offset-2" data-id="element-53">
              Política de Privacidad
            </button>
            <button onClick={() => setShowTerms(true)} className="text-sm text-navy/40 hover:text-navy/70 transition-colors underline underline-offset-2" data-id="element-54">
              Términos y Condiciones
            </button>
          </div>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      <Modal isOpen={showPrivacy} onClose={() => setShowPrivacy(false)} title="Política de Privacidad" data-id="element-55">
        <p data-id="element-56">
          <strong data-id="element-57">Última actualización:</strong> Enero 2026
        </p>
        <p data-id="element-58">
          En Protocolo 10 Días, respetamos tu privacidad y nos comprometemos a
          proteger la información personal que compartas con nosotros.
        </p>
        <p data-id="element-59">
          <strong data-id="element-60">Información que recopilamos:</strong> Al adquirir nuestro
          producto digital, recopilamos únicamente los datos necesarios para
          procesar tu compra, como tu nombre y correo electrónico.
        </p>
        <p data-id="element-61">
          <strong data-id="element-62">Uso de la información:</strong> Tu información se utiliza
          exclusivamente para enviarte el producto adquirido y comunicaciones
          relacionadas con tu compra. No vendemos, alquilamos ni compartimos tu
          información personal con terceros.
        </p>
        <p data-id="element-63">
          <strong data-id="element-64">Seguridad:</strong> Implementamos medidas de seguridad
          razonables para proteger tu información personal contra acceso no
          autorizado, alteración o destrucción.
        </p>
        <p data-id="element-65">
          <strong data-id="element-66">Cookies:</strong> Nuestro sitio puede utilizar cookies para
          mejorar tu experiencia de navegación y con fines analíticos.
        </p>
        <p data-id="element-67">
          <strong data-id="element-68">Tus derechos:</strong> Puedes solicitar acceso, corrección o
          eliminación de tus datos personales en cualquier momento.
        </p>
        <p data-id="element-69">
          Al utilizar nuestro sitio y adquirir nuestros productos, aceptas las
          prácticas descritas en esta política.
        </p>
      </Modal>

      {/* Terms Modal */}
      <Modal isOpen={showTerms} onClose={() => setShowTerms(false)} title="Términos y Condiciones" data-id="element-70">
        <p data-id="element-71">
          <strong data-id="element-72">Última actualización:</strong> Enero 2026
        </p>
        <p data-id="element-73">
          Al acceder y utilizar este sitio web y adquirir el producto "Protocolo
          10 Días: De Croquetas a Comida Real", aceptas los siguientes términos
          y condiciones.
        </p>
        <p data-id="element-74">
          <strong data-id="element-75">Producto digital:</strong> El Protocolo 10 Días es un producto
          informativo en formato PDF. No constituye asesoría veterinaria
          profesional. Siempre consulta con un veterinario antes de realizar
          cambios significativos en la dieta de tu mascota.
        </p>
        <p data-id="element-76">
          <strong data-id="element-77">Uso personal:</strong> El contenido adquirido es para uso
          personal y no puede ser redistribuido, revendido ni compartido sin
          autorización expresa.
        </p>
        <p data-id="element-78">
          <strong data-id="element-79">Entrega:</strong> Al completar tu compra, recibirás acceso
          inmediato al producto digital. Debido a la naturaleza del producto, no
          se aceptan devoluciones una vez descargado.
        </p>
        <p data-id="element-80">
          <strong data-id="element-81">Limitación de responsabilidad:</strong> Los resultados pueden
          variar según cada mascota. No garantizamos resultados específicos. El
          protocolo es una guía general y no reemplaza el consejo de un
          profesional veterinario.
        </p>
        <p data-id="element-82">
          <strong data-id="element-83">Propiedad intelectual:</strong> Todo el contenido, diseño y
          materiales del Protocolo 10 Días están protegidos por derechos de
          autor.
        </p>
        <p data-id="element-84">
          Nos reservamos el derecho de modificar estos términos en cualquier
          momento. El uso continuado del sitio implica la aceptación de los
          términos actualizados.
        </p>
      </Modal>
    </>;
}